import { useTranslation } from 'react-i18next';

import { PanelInfoWithIcon } from '@/ui';
import type { CallerVideoConnectionState, CameraState } from '@ngsos/portal-core/video';
import { showLiveVideo } from './videoCallMachine';

export type MediasoupVideoViewerProps = {
  showRecording: boolean;
  connectionState: CallerVideoConnectionState | null;
  cameraState: CameraState;
};

export function MediasoupVideoViewer({ showRecording, connectionState, cameraState }: MediasoupVideoViewerProps) {
  const { t } = useTranslation();

  return (
    <>
      <div
        className="mediasoup-video-viewer"
        style={{ display: showLiveVideo(showRecording, connectionState, cameraState) ? 'flex' : 'none' }}
      >
        <video id="remoteVideo" style={{ maxWidth: '100%' }} autoPlay playsInline muted></video>
        <audio id="remoteAudio" autoPlay></audio>
      </div>

      <video
        id="recordingVideo"
        style={{ maxWidth: '100%', display: showRecording ? 'block' : 'none' }}
        controls
        autoPlay
        playsInline
        controlsList="nofullscreen"
      ></video>

      <div id="recordingUnavailable" style={{ display: 'none' }} className="pb-4 text-center">
        <PanelInfoWithIcon>
          <img src="Images/Incident/video-canceled.svg" alt="Recording unavailable" />
          <div>{t('Incident_VideoRecordings_NotAvailable')}</div>
        </PanelInfoWithIcon>
      </div>
    </>
  );
}
